import { API_BASE_URL, API_FILE_URL, APPLICATION_SERVICE_URL } from './env.config';

const BaseUrl = API_BASE_URL;
const FileUrl = API_FILE_URL;
const lorriApplicationService = APPLICATION_SERVICE_URL;
export const Urls = {
  Transporters: {
    Get: `${BaseUrl}/api/apiuser/transporter_details`,
    Recommend: `${BaseUrl}/api/recommend_transporter`,
    UpdateTransporter: `${BaseUrl}/api/transporter`,
    SendgridEmail: `${BaseUrl}/api/apilorri/trigger_email`,
    Shortlist: `${BaseUrl}/api/shortlists `,
  },

  Users: {
    GetCurrentUser: `${BaseUrl}/api/user_details`
  },
  References: {
    Save: `${BaseUrl}/api/post_referrals`
  },
  VAS: {
    Save: `${BaseUrl}/api/post_value_added_services`
  },
  User: {
    Get: {
      ServicesAndReferrals: `${BaseUrl}/api/get_value_added_services_referrals`
    },
    Post: {
      Referral: `${BaseUrl}/api/post_value_added_services_referrals`
    }
  },
  Autocomplete: {
    Get: {
      getlist: `${BaseUrl}/api/autocomplete`
    }
  },
  MyAccount: {
    Get: {
      RatedTransporters: `${BaseUrl}/api/rated-transporters`,
      ShortlistedTransporters: `${BaseUrl}/api/shortlists`,
      ReferalsAndVAS: `${BaseUrl}/api/get_value_added_services_referrals`
    }
  },
  template: 'https://lndocs.blob.core.windows.net/transpporterlogo/index.html',
  ipinfo: `https://cors-anywhere.herokuapp.com/https://api.ipify.org/?format=json`,
  globe: 'https://adhoclorri.azurewebsites.net/api/geocoderapi',
  globeget: 'https://adhoclorri.azurewebsites.net/api/coordinates',
  azureSearch: 'https://networksearch.search.windows.net/indexes/location-index/docs?api-version=2019-05-06&search=*&$top=1000',
  locationapi: `${BaseUrl}/api/location-analysisv2?code=403uUoAMJkkEU69D8NsM0jCVxKFfvON0ROo4uLEnJQY9YfX4/9ursg==`,
  blobUrl: 'https://blobfileupload.azurewebsites.net/api/blobfile',
  services: {
    GET: `https://genericfeatures.azurewebsites.net/api/get_services`,
    POST: `https://genericfeatures.azurewebsites.net/api/post_services`
  },
  CompareUrl: `${BaseUrl}/api/transporter-comparison`,
  logURL: `${BaseUrl}/api/apilorri/log`,
  user_data: `${BaseUrl}/api/user`,
  DiscoverNow: `${BaseUrl}/api/search/transporters`,
  fileUploadService: ` https://fileuploadservice.azurewebsites.net/api/${FileUrl}`,
  getActiveprocurement: `${BaseUrl}/api/procurements/`,
  fileService: `${lorriApplicationService}/api/fileupload`
};
